import { useEffect, useState } from "react";
import { Button, Container, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import ImuWidget from "./imuWidget";
import BariCanoneSimulator from "./canoneSimulator";

export default function SurveyFasceBari() {
  const [historyCalc, setHistoryCalc] = useState<any[]>([]);
  const [userValue, setUserValue] = useState<number | null>(null);
  const [modal, setModal] = useState(true);
  const [calcState, setCalcState] = useState<any>({
    caratteristiche: [],
    mq: 0,
    arredo: "none",

    fascia: "",
    minPrice: 0,
    maxPrice: 0,
    summary: "",
  });
  const DisclaimerModal = () => {
    const handleAccept = () => {
      //localStorage.setItem("disclaimerAccepted", "true");
      setModal(false);
    };

    return (
      <Modal isOpen={modal} backdrop="static" centered keyboard={false}>
        <ModalHeader className="text-danger">Attenzione</ModalHeader>
        <ModalBody>
          Si invita sempre alla verifica dei calcoli con l'ausilio di un professionista. <br /> <br />
          L’Agenzia Sociale per la casa non è responsabile di eventuali danni e/o perdite di profitti causati dall'uso di
          Canone Giusto che viene fornito gratuitamente cosi com'è. L'utente con l'utilizzo dell'applicazione solleva
          L’Agenzia Sociale per la casa da ogni responsabilità, implicita ed esplicita, derivante dall'uso dell'applicazione
          stessa.
          <br />
          <br />
          Attenzione, si rammenta che il calcolo è effettuato esclusivamente sui dati forniti dal contribuente. E' pertanto
          necessario che il contribuente controlli con cura tutti i dati degli immobili. <br />
          <br />
          L'Amministrazione comunale non si assume nessuna responsabilità circa l'inesattezza dei dati medesimi.
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleAccept}>
            Ho capito
          </Button>
        </ModalFooter>
      </Modal>
    );
  };
  const onFormSubmit = (formData: any) => {
    // Aggiorna la logica di calcolo come facevi prima
    const diff = userValue && calcState.minPrice ? userValue - calcState.minPrice : null;

    setHistoryCalc((prev) => [
      ...prev,
      {
        ...calcState,
        imu: userValue,
        saving: diff,
      },
    ]);
  };

  const handleClick = () => {
    window.open(
      "https://cloud.ddmanagement.it/bari/admin/st800.php",
      "ddmanagement",
      "width=900,height=700,left=200,top=100,scrollbars=yes,resizable=yes"
    );
  };

  return (
    <Container>
      <div className="my-form-survey">
        <DisclaimerModal />
        <BariCanoneSimulator
          onSubmit={(result) => {
            setCalcState(result); // Aggiorna il calcolo corrente
            // console.log("Risultato ricevuto dal figlio:", result);
            // console.log(historyCalc, "history");

            setHistoryCalc((prev) => [
              ...prev,
              {
                ...calcState,
                // imu: userValue,
                fascia: result.fascia,
                minPrice: result.minPrice,
                maxPrice: result.maxPrice,
                canoneMensileMin: result.canoneMensileMin,
                canoneMensileMax: result.canoneMensileMax,
              },
            ]);
          }}
        />

        {/* Sezione IMU e risultati */}
        {/* <div style={{ marginTop: "16px", marginLeft: "17px" }}>
          <div style={{ marginTop: "20px" }}>
            <label htmlFor="externalValue">
              <strong>Inserisci IMU :</strong>
            </label>
            <input
              type="number"
              id="externalValue"
              placeholder="0"
              step="0.01"
              min={0}
              onChange={(e) => {
                const val = parseFloat(e.target.value);
                setUserValue(isNaN(val) ? null : val);
              }}
              style={{ marginLeft: "10px", padding: "4px" }}
            />
          </div>
          <strong style={{ fontSize: "25px" }}>Esito in Tempo Reale</strong> <br />
          <strong>Fascia:</strong> {calcState.fascia || "—"} <br />
          <strong>Range prezzo:</strong> € {calcState.minPrice.toFixed(2)} – € {calcState.maxPrice.toFixed(2)} <br />
          <em>{calcState.summary}</em>
        </div> */}

        {historyCalc.map((sim, index) => (
          <div
            key={index}
            style={{
              marginTop: "12px",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              marginLeft: "15px",
            }}
          >
            <strong>Fascia:</strong> {sim.fascia} <br />
            <strong>€/mq finale (dopo VINT & contratto):</strong> € {sim.minPrice} - € {sim.maxPrice}
            <br />
            <strong>Canone mensile (min–max): </strong> € {sim.canoneMensileMin} - € {sim.canoneMensileMax} <br />
            {/* <em>{sim.summary}</em> <br />
            {sim.imu && sim.saving > 0 && <strong>IMU inserito: € {sim.imu.toFixed(2)}</strong>} */}
            {/* {sim.saving > 0 && (
              <div
                style={{
                  marginTop: "10px",
                  padding: "8px",
                  border: "2px solid #b22222",
                  borderRadius: "8px",
                  backgroundColor: "#fff5f5",
                  textAlign: "center",
                }}
              >
                <strong>
                  Se affitti il tuo immobile tramite Agenzia sociale per la casa risparmierai € {sim.saving.toFixed(2)}
                </strong>
              </div>
            )} */}
          </div>
        ))}
        <p className="mt-3 ml-3">
          Per maggiori informazioni sul meccanismo di calcolo utilizzato consultare l'
          <a
            href="https://www.comune.bari.it/documents/114837/53185702/09-09-2024+Accordo+territoriale+FEDERPROPRIETA+-+UNIONCASA+-+FEDER+CASA+-+FENIT+CONFIAL+-+ANIA.pdf/42cc4462-c360-4ab2-a615-b37e001ac024"
            target="_blank"
            className="text-blue-600 font-semibold hover:underline"
          >
            ACCORDO TERRITORIALE DEL COMUNE DI BARI - 13/09/2024
          </a>
        </p>
        <div className="mt-2" style={{ fontSize: "14px", color: "#333333", marginLeft: "17px" }}>
          <strong>
            {" "}
            Si invita sempre alla verifica dei calcoli con l'ausilio di un professionista. <br /> <br />
            L’Agenzia Sociale per la casa non è responsabile di eventuali danni e/o perdite di profitti causati dall'uso di
            Canone Giusto che viene fornito gratuitamente cosi com'è. L'utente con l'utilizzo dell'applicazione solleva
            L’Agenzia Sociale per la casa da ogni responsabilità, implicita ed esplicita, derivante dall'uso
            dell'applicazione stessa.
            <br />
            <br />
            Attenzione, si rammenta che il calcolo è effettuato esclusivamente sui dati forniti dal contribuente. E' pertanto
            necessario che il contribuente controlli con cura tutti i dati degli immobili. <br />
            <br />
            L'Amministrazione comunale non si assume nessuna responsabilità circa l'inesattezza dei dati medesimi.
          </strong>
        </div>
        <div>
          {" "}
          <Button color="primary mt-5 ml-3" onClick={handleClick}>
            Calcola IMU
          </Button>
          <div className="mt-2 ml-3" style={{ fontSize: "14px", color: "grey" }}>
            Clicca su “Calcola IMU”: si aprirà la pagina esterna del Comune di Bari. <br />
            Esegui il calcolo e prendi l’importo totale dovuto (annuale, come mostrato). <br />
            Torna qui e inserisci l’importo nel campo “Quanto paghi oggi di IMU (annuale)?” in euro, senza il simbolo € e
            senza punti/spazi per le migliaia.
            <br /> Usa due decimali (es. 1234,56; se il campo non accetta la virgola, usa 1234.56).
          </div>
          <div
            style={{ marginTop: "20px", display: "flex", justifyContent: "flex-start", width: "100%", marginLeft: "17px" }}
          >
            {" "}
            <ImuWidget />
          </div>
          <p className="mt-3 ml-3">
            ⚠️ Appartamento sfitto con utenze attive: paghi la TARI come la tua prima casa (utenza principale) - stessi
            occupanti finché resta sfitto <br />
            <a
              href="https://www.comune.bari.it/documents/20181/430013/2025-DCC-29-2025-Regolamento-TARI.pdf/781a2d2c-eef0-4a3b-9c34-64e6bbd145ae"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 font-semibold hover:underline"
            >
              (Art. 13 TARI Bari 2025)
            </a>
          </p>
        </div>
      </div>
    </Container>
  );
}
